'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require('../../company/checklist/CompanyChecklistService.js');

var LIMIT = 21;

function CompanyGuestAlbumsDetailCtrl(
  $scope,
  files,
  checklists,
  translations,
  $stateParams,
  $state,
  $window,
  publication,
  CompanyPublicationFileService,
  userInformation,
  $sce,
  activityService
) {
  $scope.publication = publication;
  $scope.files               = files.slice(0, LIMIT);
  $scope.checklists          = checklists;
  $scope.translations        = translations;
  $scope.activityService     = activityService;
  $scope.currentPage         = $stateParams.page|0;
  $scope.hasMore             = files.length > LIMIT;
  $scope.searchFileStr       = $stateParams.searchFile || "";
  $scope.showInvisibleFiles  = $stateParams.showInvisible === "true";
  $scope.showFileDrop        = !$scope.showInvisibleFiles;
  $scope.userInfo = userInformation;

  if($scope.publication.type === 'ALBUM'){
    $scope.tabs = [
      {
        'title': $sce.trustAsHtml(translations['publication.information']),
          'content': '',
          'template': 'partials/company-guest/albums/detail/latest.html',
          'icon': 'info-circle'
      }
    ];
  }else{
    if($scope.publication.type === 'SK3_FOLDER'){
      $scope.tabs = [
        {
          'title': $sce.trustAsHtml(translations['publication.information']),
            'content': '',
            'template': 'partials/company-guest/sk3-folder/detail/latest.html',
            'icon': 'info-circle'
        }
      ];
      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/list.html';
    }
  }

  $scope.tabs.activeTab = 0;

  var queryFiles =  function() {
    return CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         21,
      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
      offset:        ($stateParams.page|0) * 20
    }).$promise.then(function(files) {
      $scope.$emit('publicationSaved');
      $scope.files   = files.slice(0, 20);
      $scope.hasMore = files.length > 20;
    });
  };

  $scope.$on("files-uploaded", queryFiles);
}

CompanyGuestAlbumsDetailCtrl.resolve = {
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
    return checklistService.query({
      companyId: $stateParams.companyId,
      relativeID: $stateParams.publicationId
    }).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit: LIMIT + 1,
      q: $stateParams.searchFile || "",
      offset: ($stateParams.page|0) * LIMIT,
      visible: true
    }).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestAlbumsDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestAlbumsDetailCtrl', [
  '$scope',
  'files',
  'checklists',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'publication',
  'CompanyPublicationFileService',
  'userInformation',
  '$sce',
  'activityService',
  CompanyGuestAlbumsDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/albums/CompanyGuestAlbumsDetailCtrl.js
// module id = 284
// module chunks = 0